import { useMemo } from 'preact/hooks'
import { checkConditions } from '@/components/helpers/metaobjects'
import { globalState } from '@/components/helpers/utils'
import { Criteria } from '@/components/helpers/metaobjects.types'

/**
 * Takes a criteria object to pass to checkConditions to validate what size guides should display.
 */

export function useGuides(criteria: Criteria) {
  return useMemo(() => {
    const data = globalState.metaobjects.size_guides
    return data
      .filter((guide) => checkConditions(guide, criteria))
      .sort((a, b) => a.priority - b.priority)
  }, [criteria])
}
